var _ellipse, _rect, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _ellipse2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 2.5,
    width: 28,
    height: 23,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 10,
    r: 2,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8.5,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 23,
    height: 1,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 14.5,
    width: 9,
    height: 8,
    rx: 0.5,
    stroke: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 14.5,
    width: 9,
    height: 8,
    rx: 0.5,
    stroke: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10.5,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1872_138668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 21,
    height: 20
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1777,
    cy: 14,
    rx: 10,
    ry: 10,
    fill: "#1B3D81"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1872_138668)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1777,
    cy: 14,
    rx: 10,
    ry: 10,
    fill: "#1B3D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3198 6.45042L12.8634 5.09141C13.2298 4.17562 14.209 3.66362 15.1701 3.88541L19.0821 4.78818C19.6634 4.92233 20.1545 5.30896 20.4213 5.84254L21.7091 8.41829C21.8982 8.79635 21.9626 9.22458 21.8931 9.64152L21.8135 10.1192C21.6392 11.1649 20.6619 11.8803 19.6124 11.7303L18.8993 11.6285C18.3785 11.5541 17.8791 11.8628 17.7127 12.3618C17.5824 12.7529 17.6842 13.1842 17.9757 13.4757L18.25 13.75C18.7097 14.2097 18.8702 14.8895 18.6646 15.5062L17.418 19.2459C17.1792 19.9624 16.4443 20.3889 15.7038 20.2408C15.0038 20.1008 14.5 19.4862 14.5 18.7724V18.0616C14.5 17.1438 13.8754 16.3439 12.9851 16.1213L12.1957 15.9239C11.2246 15.6811 10.5825 14.7577 10.693 13.7628L10.8421 12.4213C10.9365 11.5712 11.5611 10.8753 12.396 10.6898L15.1885 10.0692C15.3884 10.0248 15.5634 9.90489 15.677 9.73453C16.0288 9.20683 15.6505 8.5 15.0163 8.5H13.7075C12.6501 8.5 11.9272 7.43212 12.3198 6.45042Z",
    fill: "#37AA55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7832 4.98265L10.7711 4.89801C10.6196 3.83705 9.65865 3.08414 8.59224 3.19078L6.21038 3.42896C5.75099 3.4749 5.32164 3.67836 4.99518 4.00482L1.82078 7.17922C1.60961 7.39039 1.44841 7.64617 1.34901 7.92779L-1.16718 15.057C-1.37669 15.6506 -1.29449 16.3083 -0.9453 16.8321L3.01937 22.7791C3.32602 23.239 3.80938 23.5516 4.35467 23.6424L7.95015 24.2417C8.68195 24.3637 9.29886 23.6954 9.11892 22.9757C9.04368 22.6747 9.10807 22.3559 9.2942 22.1077L10.1 21.0333C10.3596 20.6871 10.5 20.2661 10.5 19.8333V19.6768C10.5 18.9505 10.1062 18.2812 9.47128 17.9285L7.30619 16.7257C6.53304 16.2961 5.56882 16.4312 4.94342 17.0566L4.66566 17.3343C3.84622 18.1538 2.4648 17.9296 1.94654 16.8931C1.46079 15.9216 1.99959 14.7501 3.05334 14.4867L3.89632 14.2759C4.58063 14.1048 5.12422 13.5859 5.3269 12.9103L6.15353 10.1549C6.32621 9.5793 5.89519 9 5.29424 9C4.55497 9 4.13298 8.15602 4.57655 7.56461L5.29105 6.61193C5.80202 5.93065 6.86787 6.10361 7.13717 6.91152C7.33249 7.49746 7.98689 7.79133 8.55459 7.54803L9.59118 7.10378C10.4224 6.74755 10.9111 5.87788 10.7832 4.98265Z",
    fill: "#37AA55"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.f07d3d26f7774d20917d474fa8498c61.svg";
export { ForwardRef as ReactComponent };